



import {Component, Vue} from 'vue-property-decorator'
import {Mutation} from 'vuex-class'
import AppButton from '@/components/common/AppButton.vue'

@Component({
  components: {
    AppButton,
  },
})
export default class SummaryInfoSignature extends Vue {
  @Mutation('setSignatureModal') public setSignatureModal!: any
  public openSignatureModal() {
    this.setSignatureModal(true)
  }
}
